var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Select2',{attrs:{"options":_vm.priceTypesForSelect2,"settings":{ width: '150px', minimumResultsForSearch: -1 }},model:{value:(_vm.price_type),callback:function ($$v) {_vm.price_type=$$v},expression:"price_type"}})
}
var staticRenderFns = []

export { render, staticRenderFns }